import "./hb-leaderboard.module.css";
import { html } from "lit-html";
import { isPopup } from "../../global";

export default (user) => html`
    <div
        id="hb-leaderboard"
        data-modal-backdrop="static"
        tabindex="-1"
        aria-hidden="true"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-2xl max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        id="hb-leaderboard-title"
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ❤️‍🔥 Leaderboard: Zero Heroes
                    </h3>
                    <button
                        onclick="window.location.hash='#'"
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-leaderboard">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div
                    class="p-4 md:p-5 my-0 space-y-4 text-base leading-[2] text-gray-900 dark:text-white">
                    <div class="overflow-x-auto shadow-md rounded-lg">
                        <table
                            class="min-w-max w-full table-auto text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                            <thead
                                class="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-900 dark:text-gray-400">
                                <tr>
                                    <th
                                        id="hb-leaderboard-rank"
                                        scope="col"
                                        class="px-3 py-3 whitespace-nowrap text-center">
                                        <div class="flex items-center">
                                            Rank
                                            <button>
                                                <svg
                                                    class="w-3 h-3 ms-1.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor"
                                                    viewBox="0 0 24 24">
                                                    <path
                                                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-3 py-3 whitespace-nowrap text-center">
                                        Players
                                    </th>
                                    <th
                                        id="hb-leaderboard-kiitos"
                                        scope="col"
                                        class="px-3 py-3 whitespace-nowrap text-center">
                                        <div class="flex items-center">
                                            Kiitos
                                            <button>
                                                <svg
                                                    class="w-3 h-3 ms-1.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor"
                                                    viewBox="0 0 24 24">
                                                    <path
                                                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </th>
                                    <th
                                        id="hb-leaderboard-kiitti"
                                        scope="col"
                                        class="px-3 py-3 whitespace-nowrap text-center">
                                        <div class="flex items-center">
                                            Kiitti
                                            <button>
                                                <svg
                                                    class="w-3 h-3 ms-1.5"
                                                    aria-hidden="true"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    fill="currentColor"
                                                    viewBox="0 0 24 24">
                                                    <path
                                                        d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
                                                </svg>
                                            </button>
                                        </div>
                                    </th>
                                    <th
                                        scope="col"
                                        class="px-3 py-3 whitespace-nowrap text-center">
                                        Location
                                    </th>
                                    <th
                                        id="hb-leaderboard-account"
                                        scope="col"
                                        class="hidden px-3 py-3 whitespace-nowrap text-center">
                                        B-Account
                                    </th>
                                    <th
                                        id="hb-leaderboard-fund"
                                        scope="col"
                                        class="hidden px-3 py-3 whitespace-nowrap text-center">
                                        B-Fund
                                    </th>
                                </tr>
                            </thead>
                            <tbody id="hb-leaderboard-body"></tbody>
                            <tfoot>
                                <tr
                                    id="hb-leaderboard-foot"
                                    class="font-semibold text-gray-900 dark:text-white bg-gray-50 dark:bg-gray-800 border-t border-gray-900"></tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
                <!-- Modal footer -->
                <p
                    class="pb-3 mt-[-5px] text-sm text-center text-gray-600 dark:text-gray-400">
                    The Zero-Point Game ℠ by Miss Aquarius™ AI
                </p>
            </div>
        </div>
    </div>
`;
